import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

function StoreDepartments() {
  const initialForm = {
    department_id: "",
    store_settings_department: "",
  };

  const [isAdmin , setIsAdmin] = useState('')

  const [formData, setFormData] = useState(initialForm);
  const [records, setRecords] = useState([]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit (Insert / Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("department_id", formData.department_id);
    fd.append("store_settings_department", formData.store_settings_department);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.CreateStoreDepartment,
        fd
      );

      if (response.data.status) {
        toast.success(response.data.success);
        setFormData(initialForm);
        fetchRecords();
      } else {
        toast.error("Failed to save department");
      }
    } catch (err) {
      toast.error("Error while saving department");
    }
  };

  // Fetch Records
  const fetchRecords = async () => {
    try {
      const response = await axios.get(
        AppConst.BASE_URL + AppConst.GetAllStoreDepartments
      );
      if (response.data.status) {
        setRecords(response.data.list);
      }
    } catch (err) {
      toast.error("Error fetching records");
    }
  };

  // Edit Record
  const handleEdit = (rec) => {
    setFormData({
      department_id: rec.id,
      store_settings_department: rec.store_settings_department,
    });
  };

  // Delete Record
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this record?")) return;

    const fd = new FormData();
    fd.append("id", id);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.DeleteStoreDepartment,
        fd
      );
      if (response.data.status) {
        toast.success("Deleted successfully");
        fetchRecords();
      } else {
        toast.error("Failed to delete");
      }
    } catch (err) {
      toast.error("Error deleting department");
    }
  };

 
   useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
      const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  
    fetchRecords();
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <div className="card-body">
                <h5>Store Departments</h5>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Department Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Department Name"
                          name="store_settings_department"
                          onChange={handleChange}
                          value={formData.store_settings_department}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="text-end">
                        <button type="submit" className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Records Table */}
            <div className="card mt-4">
              <div className="card-body">
                <h5>Departments List</h5>
                <table className="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Department</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.length > 0 ? (
                      records.map((rec) => (
                        <tr key={rec.id}>
                          <td>{rec.id}</td>
                          <td>{rec.store_settings_department}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => handleEdit(rec)}
                                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(rec.id)}
                                   disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreDepartments;
